module.exports = __webpack_public_path__ + "images/1_NOON_Director.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/1_NOON_Director.png
// module id = 258
// module chunks = 0